export default "__VITE_ASSET__bgQEBggF__"